import { IOpenStat, OpenFlag } from 'api/resort/types';
import { formatDateFromStr, FULL_DATE_FORMAT } from 'util/formatDate';
import { OpenStatus } from 'components/blocks/OpenStatus';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

const ProjectedOpeningDate = ({ status }: { status: IOpenStat }) => {
  const { t } = useOTSTranslation('common');
  const shouldShowCurrentStatus = !!status.openFlag && [OpenFlag.Open, OpenFlag.WeekendsOnly, OpenFlag.TemporarilyClosed, OpenFlag.NoReportAvailable]
    .includes(status.openFlag);
  const value = !shouldShowCurrentStatus ? formatDateFromStr(status.openingDate, FULL_DATE_FORMAT) : t('common.dash');

  return (
    <span className="h4">
      {shouldShowCurrentStatus
        ? (<OpenStatus flag={status.openFlag} />)
        : value}
    </span>
  );
};

export default ProjectedOpeningDate;
